import { SVGProps, Ref, forwardRef } from 'react'
const SvgKey = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.818 14.517 2.545-2.545 1.752.47a1.572 1.572 0 0 0 1.924-1.924l-.47-1.752.784-.784 1.752.47a1.57 1.57 0 0 0 1.924-1.924l-.47-1.752a2.357 2.357 0 0 0-3.332-3.332l-9.741 9.741a6.283 6.283 0 1 0 3.332 3.332v0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.35 18.081a1.571 1.571 0 1 0 3.142 0 1.571 1.571 0 0 0-3.142 0v0Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgKey)
export default ForwardRef
